import React, { useContext } from 'react';
import './ProductModalDetails.css';
import { ProductModalContext } from '../../ProductModalContext';
import { ContentTypes } from '../util/ProductModalEnums';
import ReactHtmlParser from 'react-html-parser';
import { formatPriceString } from '../util/ProductModalHelpers';

const ProductModalDetails = () => {
    const { productInfo, fontStyles, detailsActive, contentHeight } = useContext(ProductModalContext);

    const filterStringEnds = (str) => {
        if (!str) {
            return;
        }
        const len = str.length - 1;
        if (str[len] === ',') {
            return str.substr(0, len) + '' + str.substr(len + 1);
        }

        return str;
    }


    const [priceNum, salePriceNum] = [productInfo[ContentTypes.PRICE], productInfo[ContentTypes.SALE_PRICE]].map(price => {
        if (price || price === 0) {
            if (price % 1 !== 0) {
                return price.toFixed(2);
            }
        }
        return price;
    });
    const price = priceNum !== undefined && priceNum > 0 && <span className="des-price" >{formatPriceString(priceNum, productInfo[ContentTypes.PRICE_CURRENCY], productInfo[ContentTypes.PRICE_SUFFIX], productInfo[ContentTypes.PRICE_PREFIX])}</span>;
    const interested = <span className="interested"  >Interested in this model?</span>;
    const contact = <div className="description-contact"  ><span > <a href="tel:+1 (212) 317-8964"> CALL US: +1 (212) 317-8964</a></span> <span> <a href="mailto:concierge.us@vacheron-constantin.com">EMAIL US</a></span> <span>  <a href="https://stores.vacheron-constantin.com/search" target="_blank" >FIND A BOUTIQUE</a></span></div>;

    const details = filterStringEnds(productInfo[ContentTypes.DETAILS_BODY_1]);
    const materials = filterStringEnds(productInfo[ContentTypes.DETAILS_BODY_2]);

    return (
        <div className='product-modal-details-container' style={{ minHeight: detailsActive ? `${contentHeight}px` : 0, overflowY: 'auto', pointerEvents: detailsActive ? 'all' : 'none', opacity: detailsActive ? '1' : '0' }}>
            {materials && (
                <>
                    <div className='product-modal-content' >
                        {ReactHtmlParser(materials)}
                    </div>
                </>)}
            <div className="desc-price">
                {price}
                <div className="description-interest">
                    {interested}

                    {contact}

                </div>
            </div>
        </div>
    )
}

export default ProductModalDetails;